import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { SupportContentType, IBeetleId } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export type DeleteBatchPayloadType = {
  ids: IBeetleId[];
  env: Environment;
};

export const deleteBatchMutationKey: MutationKey = ['mutation', 'delete', 'batch'];

export const useDeleteBatch = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, DeleteBatchPayloadType>
) => {
  const { deleteBatch } = methods(method);
  return useEitherMutation(({ ids, env }) => deleteBatch(ids, env), {
    mutationKey: deleteBatchMutationKey.concat(method),
    ...options,
  });
};
